import { Routes } from '@angular/router';
import { LoginComponent } from './components/auth/login/login.component';
import { PasswordForgottenComponent } from './components/auth/password-forgotten/password-forgotten.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { MainComponent } from './components/main/main.component';
import { authGuard } from './guards/auth.guard';
import { VehiclesComponent } from './components/main/vehicles/vehicles.component';
import { dashboardGuard } from './guards/dashboard.guard';
import { SettingsComponent } from './components/main/settings/settings.component';
import { LocationsComponent } from './components/main/locations/locations.component';
import { LocationComponent } from './components/main/locations/location/location.component';
import { MeetingPointsComponent } from './components/main/meeting-points/meeting-points.component';
import { MeetingPointComponent } from './components/main/meeting-points/meeting-point/meeting-point.component';
import {
  LocationVehiclesComponent
} from "./components/main/locations/location/location-vehicles/location-vehicles.component";
import {LocationDataComponent} from "./components/main/locations/location/location-data/location-data.component";
import {EmployeesComponent} from "./components/main/employees/employees.component";
import {EmployeeComponent} from "./components/main/employees/employee/employee.component";
import {VehicleComponent} from "./components/main/vehicles/vehicle/vehicle.component";
import {RoutesComponent} from "./components/main/routes/routes.component";
import {
  SelectedRouteComponent
} from "./components/main/routes/selected-route-modal/selected-route.component";


export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [authGuard],
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'password-forgotten',
        component: PasswordForgottenComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],

  },
  {
    path: '',
    canActivate: [dashboardGuard],
    component: MainComponent,
    children: [
      {
        path: '',
        redirectTo: 'locations',
        pathMatch: 'full',
      },
      {
        path: 'vehicles',
        component: VehiclesComponent,
      },
      {
      path: 'vehicles/:id',
      component: VehicleComponent,
      },
      {
        path: 'settings',
        component: SettingsComponent,
      },
      {
        path: 'locations',
        component: LocationsComponent,
      },
      {
        path: 'locations/:id',
        component: LocationComponent,
        children: [
          {
            path: '',
            component: LocationDataComponent,
          },
          {
            path: 'vehicles',
            component: LocationVehiclesComponent,
          }
        ],
      },
      {
        path: 'meeting-points',
        component: MeetingPointsComponent,
      },
      {
        path: 'meeting-points/:id',
        component: MeetingPointComponent,
      },
      {
        path: 'employees',
        component: EmployeesComponent,
      },
      {
        path: 'employees/:id',
        component: EmployeeComponent,
      },
      {
        path: 'routes',
        component: RoutesComponent,
      },
      {
        path: 'stops/:id',
        component: SelectedRouteComponent,
      }
    ],
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
